import React, { createContext, useContext, useEffect, useState } from "react";

const STR = {
  en: {
    app_name: "Associate Skill",
    tagline: "Show your skill. Get hired. Skills first.",
    hero_line1: "Show your skill.",
    hero_line2: "Get hired.",
    hero_line3: "Skills first.",
    hero_subtitle: "Associate Skill connects skilled workers and MSMEs with employers and buyers through visual proof of skill — across languages, across borders.",
    nav_home: "Home", nav_search: "Search", nav_jobs: "Jobs", nav_dashboard: "Dashboard", nav_profile: "Profile",
    cta_create_profile: "Create Profile", cta_upload_video: "Upload Skill Video",
    cta_post_opportunity: "Post Opportunity", cta_apply: "Apply Now",
    role_individual: "Skilled Worker", role_individual_desc: "Electrician, welder, beautician, carpenter…",
    role_msme: "MSME / Service Provider", role_msme_desc: "Small business offering services or production.",
    role_employer: "Employer / Buyer", role_employer_desc: "Hire talent or post RFQs.",
    role_admin: "Admin", role_admin_desc: "Verify and moderate the platform.",
    role_sponsor: "Sponsor / CSR", role_sponsor_desc: "Fund verifications, badges, and skill cohorts.",
    sign_up: "Sign Up", login: "Login", logout: "Logout",
    name: "Full name", email: "Email", phone: "Phone", password: "Password",
    city: "City", state: "State", country: "Country",
    skills: "Skills", years_experience: "Years of experience", education: "Education / Certifications",
    availability: "Availability", expected_rate: "Expected rate",
    company_name: "Company name", sectors: "Sectors", team_size: "Team size", monthly_capacity: "Monthly capacity",
    service_locations: "Service locations", export_capable: "Export capable",
    organization_name: "Organization name", industry: "Industry",
    bio: "About / Bio", headline: "Headline",
    save: "Save", cancel: "Cancel", continue: "Continue",
    media_gallery: "Skill portfolio", upload: "Upload",
    select_skill: "Select skill", required_skills: "Required skills",
    description: "Description", title: "Title",
    post_job: "Post Job", op_type: "Type", op_job: "Job", op_gig: "Gig",
    op_apprenticeship: "Apprenticeship", op_rfq: "RFQ",
    budget: "Budget", remote: "Remote", on_site: "On-site",
    apply_message: "Why are you a good fit?", proposed_rate: "Proposed rate",
    applications: "Applications", applicants: "Applicants",
    shortlisted: "Shortlisted", selected: "Selected", rejected: "Rejected", applied: "Applied",
    verified: "Verified", unverified: "Unverified", pending: "Pending",
    search_talent: "Find skilled people", search_jobs: "Find work",
    filter_skill: "Filter by skill", filter_city: "Filter by city",
    filter_min_exp: "Min. experience", filter_verified: "Verified only",
    no_results: "No results yet.", reviews: "Reviews", rating: "Rating",
    transcript: "Transcript", language: "Language",
    admin_dashboard: "Admin dashboard", users: "Users", opportunities: "Opportunities",
    flagged: "Flagged content", verify: "Verify", add_badge: "Add badge",
    welcome_back: "Welcome back", get_started: "Get started", choose_role: "Choose your role",
    profile_saved: "Profile saved", uploaded: "Uploaded", error_occurred: "Something went wrong",
    upload_image: "Upload image", upload_video: "Upload video",
    spoken_language: "Spoken language",
    skill_tags: "Skill tags",
    posted_by: "Posted by", location: "Location",
    matching_candidates: "Matching candidates", match_score: "Match score",
    close_op: "Close opportunity", op_closed: "Closed", op_open: "Open",
    no_media: "No portfolio items yet.",
    edit_profile: "Edit profile",
    new_opportunity: "New opportunity",
    my_applications: "My applications",
    my_opportunities: "My opportunities",
    full_time: "Full-time", part_time: "Part-time", gig: "Gig", on_site_work: "On-site",
    status: "Status",
  },
  hi: {
    app_name: "एसोसिएट स्किल",
    tagline: "अपना हुनर दिखाएँ। काम पाएँ। स्किल सबसे पहले।",
    hero_line1: "अपना हुनर दिखाएँ।",
    hero_line2: "काम पाएँ।",
    hero_line3: "स्किल सबसे पहले।",
    hero_subtitle: "एसोसिएट स्किल कुशल कामगारों और एमएसएमई को नियोक्ताओं और खरीदारों से उनके काम के दृश्य प्रमाण के माध्यम से जोड़ता है — भाषाओं और सीमाओं के पार।",
    nav_home: "होम", nav_search: "खोजें", nav_jobs: "नौकरी", nav_dashboard: "डैशबोर्ड", nav_profile: "प्रोफ़ाइल",
    cta_create_profile: "प्रोफ़ाइल बनाएँ", cta_upload_video: "स्किल वीडियो अपलोड करें",
    cta_post_opportunity: "अवसर पोस्ट करें", cta_apply: "अभी आवेदन करें",
    role_individual: "कुशल कामगार", role_individual_desc: "इलेक्ट्रिशियन, वेल्डर, ब्यूटीशियन, बढ़ई…",
    role_msme: "एमएसएमई / सेवा प्रदाता", role_msme_desc: "सेवाएँ या उत्पादन देने वाला छोटा व्यवसाय।",
    role_employer: "नियोक्ता / खरीदार", role_employer_desc: "प्रतिभा नियुक्त करें या आरएफक्यू पोस्ट करें।",
    role_admin: "एडमिन", role_admin_desc: "प्लेटफ़ॉर्म सत्यापित और मॉडरेट करें।",
    role_sponsor: "स्पॉन्सर / सीएसआर", role_sponsor_desc: "सत्यापन, बैज और स्किल कोहोर्ट को फंड करें।",
    sign_up: "साइन अप", login: "लॉगिन", logout: "लॉगआउट",
    name: "पूरा नाम", email: "ईमेल", phone: "फ़ोन", password: "पासवर्ड",
    city: "शहर", state: "राज्य", country: "देश",
    skills: "कौशल", years_experience: "अनुभव के वर्ष", education: "शिक्षा / प्रमाणपत्र",
    availability: "उपलब्धता", expected_rate: "अपेक्षित दर",
    company_name: "कंपनी का नाम", sectors: "क्षेत्र", team_size: "टीम का आकार", monthly_capacity: "मासिक क्षमता",
    service_locations: "सेवा स्थान", export_capable: "निर्यात सक्षम",
    organization_name: "संगठन का नाम", industry: "उद्योग",
    bio: "परिचय", headline: "शीर्षक",
    save: "सहेजें", cancel: "रद्द करें", continue: "जारी रखें",
    media_gallery: "स्किल पोर्टफ़ोलियो", upload: "अपलोड",
    select_skill: "कौशल चुनें", required_skills: "आवश्यक कौशल",
    description: "विवरण", title: "शीर्षक",
    post_job: "नौकरी पोस्ट करें", op_type: "प्रकार", op_job: "नौकरी", op_gig: "गिग",
    op_apprenticeship: "प्रशिक्षु", op_rfq: "आरएफक्यू",
    budget: "बजट", remote: "रिमोट", on_site: "ऑन-साइट",
    apply_message: "आप क्यों उपयुक्त हैं?", proposed_rate: "प्रस्तावित दर",
    applications: "आवेदन", applicants: "आवेदक",
    shortlisted: "शॉर्टलिस्ट", selected: "चयनित", rejected: "अस्वीकृत", applied: "आवेदित",
    verified: "सत्यापित", unverified: "असत्यापित", pending: "लंबित",
    search_talent: "कुशल लोग खोजें", search_jobs: "काम खोजें",
    filter_skill: "कौशल से फ़िल्टर", filter_city: "शहर से फ़िल्टर",
    filter_min_exp: "न्यूनतम अनुभव", filter_verified: "केवल सत्यापित",
    no_results: "अभी कोई परिणाम नहीं।", reviews: "समीक्षाएँ", rating: "रेटिंग",
    transcript: "ट्रांसक्रिप्ट", language: "भाषा",
    admin_dashboard: "एडमिन डैशबोर्ड", users: "उपयोगकर्ता", opportunities: "अवसर",
    flagged: "फ़्लैग किया गया", verify: "सत्यापित करें", add_badge: "बैज जोड़ें",
    welcome_back: "वापसी पर स्वागत है", get_started: "शुरू करें", choose_role: "अपनी भूमिका चुनें",
    profile_saved: "प्रोफ़ाइल सहेजी गई", uploaded: "अपलोड हुआ", error_occurred: "कुछ गलत हो गया",
    upload_image: "चित्र अपलोड करें", upload_video: "वीडियो अपलोड करें",
    spoken_language: "बोलने की भाषा",
    skill_tags: "स्किल टैग",
    posted_by: "पोस्ट किया", location: "स्थान",
    matching_candidates: "मेल खाते उम्मीदवार", match_score: "मैच स्कोर",
    close_op: "अवसर बंद करें", op_closed: "बंद", op_open: "खुला",
    no_media: "अभी कोई पोर्टफ़ोलियो नहीं।",
    edit_profile: "प्रोफ़ाइल संपादित करें",
    new_opportunity: "नया अवसर",
    my_applications: "मेरे आवेदन",
    my_opportunities: "मेरे अवसर",
    full_time: "फ़ुल-टाइम", part_time: "पार्ट-टाइम", gig: "गिग", on_site_work: "ऑन-साइट",
    status: "स्थिति",
  },
  te: {
    app_name: "అసోసియేట్ స్కిల్",
    tagline: "మీ నైపుణ్యాన్ని చూపండి. పని పొందండి. స్కిల్స్ ముందుగా.",
    hero_line1: "మీ నైపుణ్యాన్ని చూపండి.",
    hero_line2: "పని పొందండి.",
    hero_line3: "స్కిల్స్ ముందుగా.",
    hero_subtitle: "అసోసియేట్ స్కిల్ నైపుణ్యం గల కార్మికులు మరియు ఎంఎస్ఎంఈలను యజమానులు మరియు కొనుగోలుదారులతో నైపుణ్యం యొక్క దృశ్య రుజువు ద్వారా కలుపుతుంది — భాషలు మరియు సరిహద్దుల అడ్డుపడకుండా.",
    nav_home: "హోమ్", nav_search: "శోధన", nav_jobs: "ఉద్యోగాలు", nav_dashboard: "డాష్‌బోర్డ్", nav_profile: "ప్రొఫైల్",
    cta_create_profile: "ప్రొఫైల్ క్రియేట్ చేయండి", cta_upload_video: "స్కిల్ వీడియో అప్‌లోడ్",
    cta_post_opportunity: "అవకాశం పోస్ట్ చేయండి", cta_apply: "ఇప్పుడు దరఖాస్తు",
    role_individual: "నైపుణ్యం గల కార్మికుడు", role_individual_desc: "ఎలక్ట్రీషియన్, వెల్డర్, బ్యూటీషియన్, వడ్రంగి…",
    role_msme: "ఎంఎస్ఎంఈ / సర్వీస్ ప్రొవైడర్", role_msme_desc: "సేవలు లేదా ఉత్పత్తిని అందించే చిన్న వ్యాపారం.",
    role_employer: "ఎంప్లాయర్ / కొనుగోలుదారు", role_employer_desc: "ప్రతిభను నియమించండి లేదా RFQ పోస్ట్ చేయండి.",
    role_admin: "అడ్మిన్", role_admin_desc: "ప్లాట్‌ఫాంను ధృవీకరించి మోడరేట్ చేయండి.",
    role_sponsor: "స్పాన్సర్ / CSR", role_sponsor_desc: "వెరిఫికేషన్లు, బ్యాడ్జ్‌లు మరియు స్కిల్ కోహార్ట్‌లను ఫండ్ చేయండి.",
    sign_up: "సైన్ అప్", login: "లాగిన్", logout: "లాగౌట్",
    name: "పూర్తి పేరు", email: "ఈమెయిల్", phone: "ఫోన్", password: "పాస్‌వర్డ్",
    city: "నగరం", state: "రాష్ట్రం", country: "దేశం",
    skills: "నైపుణ్యాలు", years_experience: "అనుభవ సంవత్సరాలు", education: "విద్య / సర్టిఫికేషన్లు",
    availability: "లభ్యత", expected_rate: "అంచనా రేటు",
    company_name: "కంపెనీ పేరు", sectors: "రంగాలు", team_size: "టీమ్ పరిమాణం", monthly_capacity: "నెలవారీ సామర్థ్యం",
    service_locations: "సేవా ప్రాంతాలు", export_capable: "ఎగుమతి సామర్థ్యం",
    organization_name: "సంస్థ పేరు", industry: "పరిశ్రమ",
    bio: "గురించి", headline: "హెడ్‌లైన్",
    save: "సేవ్", cancel: "రద్దు", continue: "కొనసాగించు",
    media_gallery: "స్కిల్ పోర్ట్‌ఫోలియో", upload: "అప్‌లోడ్",
    select_skill: "నైపుణ్యాన్ని ఎంచుకోండి", required_skills: "అవసరమైన నైపుణ్యాలు",
    description: "వివరణ", title: "శీర్షిక",
    post_job: "ఉద్యోగం పోస్ట్ చేయండి", op_type: "రకం", op_job: "ఉద్యోగం", op_gig: "గిగ్",
    op_apprenticeship: "శిక్షణార్థి", op_rfq: "RFQ",
    budget: "బడ్జెట్", remote: "రిమోట్", on_site: "ఆన్-సైట్",
    apply_message: "మీరు ఎందుకు సరిపోతారు?", proposed_rate: "ప్రతిపాదిత రేటు",
    applications: "దరఖాస్తులు", applicants: "దరఖాస్తుదారులు",
    shortlisted: "షార్ట్‌లిస్ట్", selected: "ఎంపిక", rejected: "తిరస్కరణ", applied: "దరఖాస్తు చేశారు",
    verified: "ధృవీకరించబడింది", unverified: "ధృవీకరించబడలేదు", pending: "పెండింగ్",
    search_talent: "నైపుణ్యం గల వారిని కనుగొనండి", search_jobs: "పని కనుగొనండి",
    filter_skill: "నైపుణ్యం ద్వారా ఫిల్టర్", filter_city: "నగరం ద్వారా ఫిల్టర్",
    filter_min_exp: "కనీస అనుభవం", filter_verified: "ధృవీకరించిన వారు మాత్రమే",
    no_results: "ఫలితాలు లేవు.", reviews: "సమీక్షలు", rating: "రేటింగ్",
    transcript: "ట్రాన్స్క్రిప్ట్", language: "భాష",
    admin_dashboard: "అడ్మిన్ డాష్‌బోర్డ్", users: "వినియోగదారులు", opportunities: "అవకాశాలు",
    flagged: "ఫ్లాగ్ చేయబడింది", verify: "ధృవీకరించు", add_badge: "బ్యాడ్జ్ జోడించండి",
    welcome_back: "తిరిగి స్వాగతం", get_started: "ప్రారంభించండి", choose_role: "మీ పాత్రను ఎంచుకోండి",
    profile_saved: "ప్రొఫైల్ సేవ్ చేయబడింది", uploaded: "అప్‌లోడ్ అయింది", error_occurred: "తప్పు జరిగింది",
    upload_image: "చిత్రం అప్‌లోడ్", upload_video: "వీడియో అప్‌లోడ్",
    spoken_language: "మాట్లాడే భాష",
    skill_tags: "స్కిల్ ట్యాగ్‌లు",
    posted_by: "పోస్ట్ చేసినవారు", location: "ప్రాంతం",
    matching_candidates: "సరిపోలే అభ్యర్థులు", match_score: "మ్యాచ్ స్కోర్",
    close_op: "అవకాశం మూసివేయండి", op_closed: "మూసివేయబడింది", op_open: "తెరిచి ఉంది",
    no_media: "పోర్ట్‌ఫోలియో లేదు.",
    edit_profile: "ప్రొఫైల్ ఎడిట్",
    new_opportunity: "కొత్త అవకాశం",
    my_applications: "నా దరఖాస్తులు",
    my_opportunities: "నా అవకాశాలు",
    full_time: "ఫుల్-టైమ్", part_time: "పార్ట్-టైమ్", gig: "గిగ్", on_site_work: "ఆన్-సైట్",
    status: "స్థితి",
  },
};

export const LANGUAGES = [
  { code: "en", label: "English" },
  { code: "hi", label: "हिन्दी" },
  { code: "te", label: "తెలుగు" },
];

const I18nCtx = createContext({ lang: "en", setLang: () => {}, t: (k) => k });

export function I18nProvider({ children }) {
  const [lang, setLangState] = useState(() => localStorage.getItem("as_lang") || "en");
  useEffect(() => { localStorage.setItem("as_lang", lang); }, [lang]);
  const setLang = (l) => setLangState(l);
  const t = (key) => (STR[lang] && STR[lang][key]) || STR.en[key] || key;
  return <I18nCtx.Provider value={{ lang, setLang, t }}>{children}</I18nCtx.Provider>;
}

export const useI18n = () => useContext(I18nCtx);
